function parseISODurationToDays(isoDuration) {
  const regex = /^P(?:(\d+)D)?(?:T(?:(\d+)H)?)?$/;
  const match = isoDuration?.match(regex);

  if (!match) return 0;

  const days = parseInt(match[1] || '0', 10);
  const hours = parseInt(match[2] || '0', 10);

  // Convert everything to days
  return days + hours / 24;
}

function normalizeSchedule(slots, scheduleType) {
  if (scheduleType === 'slots') {
    return slots?.map((schedule) => ({
      from: schedule?.from
        ? `${String(schedule.from).padStart(2, '0')}.00`
        : '',
      to: schedule?.to ? `${String(schedule.to).padStart(2, '0')}.00` : '',
      day: schedule?.day,
    }));
  }

  return slots?.map((schedule) => ({
    from: '11.00',
    to: '11.00',
    day: schedule,
  }));
}

export const mapDataForClient = (data) => ({
  scheduleType: data?.scheduleType,
  bookingRule: {
    minDuration: parseISODurationToDays(data?.bookingRule?.minDuration),
    maxDuration: parseISODurationToDays(data?.bookingRule?.maxDuration),
    notBefore: parseISODurationToDays(data?.bookingRule?.notBefore),
    notAfter: parseISODurationToDays(data?.bookingRule?.notAfter),
  },
  available: data?.available,
  schedules: normalizeSchedule(data?.slots, data?.scheduleType),
});
